import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWeatherShumShi = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 31.466,
	height: 27.266,
	viewBox: "0 0 31.466 27.266",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_6633",
		"data-name": "Group 6633",
		transform: "translate(12936.145 12323.061)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_9044",
				"data-name": "Path 9044",
				d: "M176.7,8.382a4.208,4.208,0,0,0-5.265,3.669,4.221,4.221,0,1,0-2.064,7.9,4.01,4.01,0,0,0,.624-.051,4.216,4.216,0,0,0,5.617,2.38,7.236,7.236,0,0,0,5.014,1.8c2.773,0,5.114-1.269,5.871-3.011a4.213,4.213,0,0,0,6.43-1.784c2.15-.6,3.683-2.145,3.683-3.96,0-2.331-2.528-4.222-5.646-4.222a7.368,7.368,0,0,0-1.093.081A4.692,4.692,0,0,0,185.6,8.651a5.331,5.331,0,0,0-.624.041,4.218,4.218,0,0,0-8.28-.31",
				transform: "translate(-13101.289 -12328.172)",
				fill: "#67a4fe"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_9045",
				"data-name": "Path 9045",
				d: "M171.431,27.187a1.62,1.62,0,1,0,3.123.719c.231-1-.847-3.461-.847-3.461s-2.045,1.739-2.276,2.742",
				transform: "translate(-13101.289 -12328.172)",
				fill: "#67a4fe"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_9046",
				"data-name": "Path 9046",
				d: "M178.017,28.511a2.048,2.048,0,1,0,3.946.91c.292-1.266-1.07-4.375-1.07-4.375s-2.585,2.2-2.876,3.465",
				transform: "translate(-13101.289 -12328.172)",
				fill: "#67a4fe"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_9047",
				"data-name": "Path 9047",
				d: "M169.156,24.633a1.14,1.14,0,1,0,2.2.507,6.278,6.278,0,0,0-.6-2.437s-1.44,1.224-1.6,1.93",
				transform: "translate(-13101.289 -12328.172)",
				fill: "#67a4fe"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_9048",
				"data-name": "Path 9048",
				d: "M190.42,24.265a1.14,1.14,0,1,0,2.2.507,6.277,6.277,0,0,0-.6-2.436s-1.439,1.224-1.6,1.929",
				transform: "translate(-13101.289 -12328.172)",
				fill: "#67a4fe"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_9049",
				"data-name": "Path 9049",
				d: "M183,26.007a1.14,1.14,0,1,0,2.2.507,6.257,6.257,0,0,0-.6-2.436s-1.44,1.224-1.6,1.929",
				transform: "translate(-13101.289 -12328.172)",
				fill: "#67a4fe"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_9050",
				"data-name": "Path 9050",
				d: "M175.585,26.374a1.14,1.14,0,1,0,2.2.507,6.275,6.275,0,0,0-.6-2.436s-1.439,1.224-1.6,1.929",
				transform: "translate(-13101.289 -12328.172)",
				fill: "#67a4fe"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_9051",
				"data-name": "Path 9051",
				d: "M182.551,30.827a1.14,1.14,0,1,0,2.2.506,6.262,6.262,0,0,0-.6-2.436s-1.439,1.224-1.6,1.93",
				transform: "translate(-13101.289 -12328.172)",
				fill: "#67a4fe"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_9052",
				"data-name": "Path 9052",
				d: "M166.145,22.891a1.14,1.14,0,1,0,2.2.506,6.28,6.28,0,0,0-.6-2.436s-1.439,1.224-1.6,1.93",
				transform: "translate(-13101.289 -12328.172)",
				fill: "#67a4fe"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_9053",
				"data-name": "Path 9053",
				d: "M193.483,21.424a1.14,1.14,0,1,0,2.2.507,6.272,6.272,0,0,0-.6-2.436s-1.439,1.224-1.6,1.929",
				transform: "translate(-13101.289 -12328.172)",
				fill: "#67a4fe"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_9054",
				"data-name": "Path 9054",
				d: "M185.788,27.187a1.62,1.62,0,1,0,3.122.719c.23-1-.847-3.461-.847-3.461s-2.045,1.739-2.275,2.742",
				transform: "translate(-13101.289 -12328.172)",
				fill: "#67a4fe"
			})
		]
	})
});
export { SvgWeatherShumShi as ReactComponent };
